import { render, staticRenderFns } from "./groupFinalRevival.vue?vue&type=template&id=43b23996&scoped=true"
import script from "./groupFinalRevival.vue?vue&type=script&lang=js"
export * from "./groupFinalRevival.vue?vue&type=script&lang=js"
import style0 from "./groupFinalRevival.vue?vue&type=style&index=0&id=43b23996&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b23996",
  null
  
)

export default component.exports